// Hidden for the 2026-10 SF demo; other regions may turn it back on.
// Scenario 5 (Pricing + Transit Investment, with its +10/+25/+50% service levels) and the
// Transit Investment case study. Nothing is deleted: true brings all of it back.
export const SHOW_TRANSIT_SCENARIO = false;

const isTransitScenario = (s) => s.id === 'pricing-transit' || s.variant_of === 'pricing-transit';

/** A pack's or the workshop's scenario list, without scenario 5 while it is hidden. */
export const visibleScenarios = (scenarios) =>
  (SHOW_TRANSIT_SCENARIO ? scenarios : scenarios.filter((s) => !isTransitScenario(s)));

// true (the SF demo): Origin-Destination Analytics offers Trips into the zone, Analytics
// (whose V/C metric is the Congestion Pricing map) and Accessibility; scenario 5 is kept
// out of all of them by SHOW_TRANSIT_SCENARIO above.
// false: no Trips into the zone tab, no V/C metric, and a Scenario Comparison thumbnail
// only selects its column (no double-click to that map).
export const SHOW_OD_PRICING_TABS = true;
